module.exports = "/images/lines-7.jpg";